module.exports = __webpack_public_path__ + "static/media/madonna-with-child-fixed.39ee1d9f.jpg";